module.exports = {
	"_format": "hh-sol-artifact-1",
	"contractName": "$",
	"sourceName": "contracts/levels/DiscoLP.sol",
	"abi": [],
	"bytecode": "0x60566023600b82828239805160001a607314601657fe5b30600052607381538281f3fe73000000000000000000000000000000000000000030146080604052600080fdfea26469706673582212208034b7fda9be6349ae6cb36745eda05ea1e378833482cca767eee83af6b4cd0564736f6c634300060c0033",
	"deployedBytecode": "0x73000000000000000000000000000000000000000030146080604052600080fdfea26469706673582212208034b7fda9be6349ae6cb36745eda05ea1e378833482cca767eee83af6b4cd0564736f6c634300060c0033",
	"linkReferences": {},
	"deployedLinkReferences": {}
};


//////////////////
// WEBPACK FOOTER
// ./build/contracts/levels/DiscoLP.sol/$.json
// module id = 1529
// module chunks = 0